import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Editor, Toolbar } from 'ngx-editor';

@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrl: './text-editor.component.less',
})
export class TextEditorComponent {
  editor!: Editor;
  @Input() value: string = '';
  @Output() valueChange = new EventEmitter();
  @Input() disabled: boolean = false;
  @Input() placeholder: string = '';
  @Input() readonly: boolean = false;
  @Input() required: boolean = false;
  @Input() isTextEditorDisabledByDefault: boolean = false;
  showPlaceholder: boolean = true;
  toolbar: Toolbar = [
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['bold'],
    ['italic'],
    ['underline'],
    ['strike'],
    ['ordered_list'],
    ['bullet_list'],
    ['undo'],
    ['redo'],
    ['align_left'],
    ['align_center'],
    ['align_right'],
    ['align_justify'],
    ['indent'],
    ['outdent'],
    ['code'],
    ['image'],
    ['link'],
  ];
  editorValue: string = '';
  public get _editorValue(): string {
    return this.editorValue;
  }
  public set _editorValue(v: string) {
    this.editorValue = v;
    this.onChange(v);
  }
  ngOnDestroy(): void {
    this.editor.destroy();
  }
  onChange(val: string) {
    if (!this.showPlaceholder) {
      if (val == '<p></p>') {
        val = '';
      }
      this.value = val;
      this.valueChange.emit(val);
      this.editorValue = val;
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['value'] &&
      changes['value'].currentValue !== changes['value'].previousValue
    ) {
      this.editorValue =
        this.value && this.value.length > 0 && this.value !== '<p></p>'
          ? this.value
          : this.placeholder;
    }
  }
  ngOnInit() {
    this.editor = new Editor();
    this.editorValue =
      this.value?.length > 0 && this.value != '<p></p>'
        ? this.value
        : this.placeholder;
    document.addEventListener(
      'click',
      (event: any) => {
        const parentClass = event.target?.parentNode?.className ?? '';
        const childClass = event.target?.className ?? '';
        try {
          if (
            !childClass.includes('NgxEditor') &&
            !parentClass.includes('NgxEditor') &&
            !parentClass.includes('code_icon') &&
            !childClass.includes('code_icon')
          ) {
            const isEmptyContent =
              this.editorValue.trim() === '' || this.editorValue === '<p></p>';
            if (!isEmptyContent) {
              return;
            }
            if (this.value?.length > 0 && this.value != '<p></p>') {
              this.editorValue = this.value;
            } else {
              this.showPlaceholder = true;
              this.editorValue = this.placeholder;
            }
          }
        } catch (error) {
          // Error will be triggered if any element didn't have classname. No need to handle
        }
      },
      true
    );
  }
  enableEdit(event: Event) {
    if (this.disabled || this.readonly) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }
    this.showPlaceholder = false;
    this.editorValue = this.value;
    event.stopPropagation();
    event.preventDefault();
  }
  get isTextEditorDisabled(): boolean {
    return (
      this.isTextEditorDisabledByDefault &&
      this.showPlaceholder &&
      this.value?.length > 0 &&
      this.value != '<p></p>'
    );
  }
}
